import type { RouteConfig } from 'vue-router';

export const employeesRoutes: Array<RouteConfig> = [
  {
    path: 'employees',
    redirect: '/v3/time-tracking/employees',
    children: [
      {
        path: '',
        name: 'employees',
        redirect: '/v3/time-tracking/employees',
      },
      {
        path: 'inactive',
        name: 'employees-inactive',
        redirect: '/v3/time-tracking/employees/inactive',
      },
    ],
  },
];
